/**
 * @cloudnest/augmented-chess-ui
 * Shared chess UI components for augmented chess applications
 *
 * Provides inline, Tailwind CSS, and CSS Theme variants of all components.
 * Default exports use inline styles for backward compatibility.
 */

export {
  PlayerAugmentationsPanel,
  PlayerAugmentationsPanelThemed,
} from "./augmentation/player-panel";
// Augmentation components
export {
  AugmentationSelectionModal,
  AugmentationSelectionModalThemed,
} from "./augmentation/selection-modal";
export type { BoardBaseProps, PieceBaseProps, SquareBaseProps } from "./core";
// Core components (default = inline styles)
export { Board, BoardBase, BoardTailwind, BoardThemed } from "./core/board";
export { Piece, PieceBase, PieceTailwind, PieceThemed } from "./core/piece";
export {
  Square,
  SquareBase,
  SquareTailwind,
  SquareThemed,
} from "./core/square";
// Types
export type {
  AugmentationSelectionModalProps,
  BoardProps,
  PieceAugmentationMap,
  PieceProps,
  PlayerAugmentationsPanelProps,
  SquareProps,
} from "./types";

// Utils
export { FILES, isLightSquare, RANKS } from "./utils/board-constants";
export { getPieceSymbol, PIECE_SYMBOLS } from "./utils/piece-symbols";
